import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2";
import { getTransaction } from '../utils/Api/ApiCalls';
import { useParams } from 'react-router-dom';

const TransactionDetails = () => {
    const [ transactionData, setTransactionData ] = useState({});
    useEffect(() => {
        getAllTransaction();
 }, []);
 const params = useParams();
 const getAllTransaction = async () => {
     try {
         const response = await getTransaction(params.transactionId);
         setTransactionData(response.transaction);
         
     } catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
 };
    return (
            <section class='content-main'>
                <div className="row">
					<div class='col-md-8'>
						<div class='card mb-4'>
							<div class='card-header d-flex justify-content-between align-items-center'>
								<h4>Transaction Details</h4>
                                <div>
                                <h6 class='mb-0'>Date:</h6>
                        <p>{new Date(transactionData.TransactionDate).toDateString()}</p>
                                </div>
							</div>
							<div class='card-body'>
                <div class="row">
                    {/* <div class='box bg-light' style={{ minHeight: "80%" }}> */}
                        {/* <h6 class='mt-15'>Transaction Details</h6> */}
                        {/* <hr /> */}
                        <div className="col-md-6 mb-3">
                        <h6 class='mb-0'>Customer Name:</h6>
                        <p>{transactionData.CustomerName}</p>
                        </div>
                       <div className="col-md-6 mb-3">
                        <h6 class='mb-0'>Email:</h6>
                        <p>{transactionData.CustomerEmail}</p>
                      </div>
                      <div className="col-md-6 mb-3">
                        <h6 class='mb-0'>Payment Type:</h6>
                        <p>{transactionData.PaymentMethod && toProperCase(transactionData.PaymentMethod)}</p>
                      </div>
                       <div className="col-md-6 mb-3">
                        <h6 class='mb-0'>Date:</h6>
                        <p>{new Date(transactionData.TransactionDate).toDateString()}</p>
                        </div>
                        <div className="col-md-6 mb-3">
                        <h6 class='mb-0'>Amount:</h6>
                        <p>₦{parseFloat(transactionData?.Amount?.toString().substr(0, transactionData?.Amount?.toString().length - 2)).toLocaleString()}</p>
                        </div>
                        <div className="col-md-6 mb-3">
                        <h6 class='mb-0'>Transaction Reference:</h6>
                        <p>{transactionData.TransactionId}</p>
                        </div>
                        <div className="col-md-6 mb-3">
                        <h6 class='mb-0'>Payment Status:</h6>
                        <p>{transactionData.Status && toProperCase(transactionData.Status)}</p>
                        </div>
                        {/* <h6 class='mb-0'>Item purchased:</h6>
                        <br />
                        <p>
                            <a href='#'>
                                Adidas Air Jordan{" "}
                                <i class='icons material-icons md-launch'></i>
                            </a>
                            <br />
                            <a href='#'>
                                {" "}
                                Great product <i class='icons material-icons md-launch'></i>{" "}
                            </a>
                        </p>
                        <br />
                        <p>Payment: PayPal</p>
                        <p class='h4'>$457.14</p>
                        <hr />
                        <a class='btn btn-light' href='#'>
                            {" "}
                            Download receipe{" "}
                        </a> */}
                    </div>
                </div>
                </div>
                </div>
                </div>
            </section>
    );
}

export default TransactionDetails;

const toProperCase = (text) => {
	return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
  };